module.exports = __webpack_public_path__ + "static/media/manual_edit_bold.19f2e718.jpg";